import { format as dateFormat } from 'date-fns';

export function formatDate(date: Date | string | number | null | undefined, format = 'dd/MM/yyyy') {
  if (!date) {
    return '';
  }

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return '';
  }

  return dateFormat(parsedDate, format);
}

export function formatDateForBackend(date: Date | string | null) {
  if (!date) {
    return null;
  }

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return null;
  }

  return dateFormat(parsedDate, 'yyyy-MM-dd');
}

export const getDateIncreasedByDays = (days?: number) => {
  if (!Number.isFinite(days)) {
    return;
  }

  const date = new Date();
  date.setDate(date.getDate() + days!);

  return date;
};

export const getDateDecreasedByDays = (days?: number) => {
  if (!Number.isFinite(days)) {
    return;
  }

  const date = new Date();
  date.setDate(date.getDate() - days!);

  return date;
};
